<template>
	<v-layout row wrap>

		<v-flex class="mb-4" xs12 >
			<h1 class="title mb-2">My Payslip</h1>
			<div style="min-height:400px;">
				<v-card class="mb-3 mr-3" >
					<v-toolbar card class="blue dark-3">
						<span class="title white--text">List of Payslip</span>
					</v-toolbar>
					<v-list class="ma-0 pa-0">
						<template v-for="(payslip,i) in payslips">
							<v-list-tile :class=" (i%2)? 'grey lighten-4' : 'grey lighten-3' ">	
								<v-list-tile-avatar>
					              <v-icon color="light-blue darken-3">fas fa-file-alt</v-icon>
					            </v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title><span class="font-weight-medium">Payroll Period</span> &nbsp; <span class="font-weight-light">{{ payslip.payroll_period_from }} - {{ payslip.payroll_period_to}}</span></v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
					              <v-btn
					              	depressed
									color="light-blue lighten-1"
									class="white--text"
									@click="payslipDetailsFunc(payslip)"
									target="_blank"
									>View
										<v-icon right small dark>fas fa-search</v-icon>
									</v-btn>
					            </v-list-tile-action>
							</v-list-tile>
						</template>
						<v-layout row wrap class="text-xs-center">
							<v-flex md12>
								<v-pagination
								v-model="pagination.page"
								:length="pagination.length"
								:disabled="isLoading"
								total-visible="10" 
								circle>
									
								</v-pagination>
							</v-flex>
						</v-layout>
					</v-list>
				</v-card>
			</div>
		</v-flex>

		<v-dialog
        v-model="payslipDetailsDialog"

        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      	>
        <v-card tile>
	      <v-toolbar
            flat
            dark
            color="primary"
	        >
            <v-btn
              icon
              dark
              @click="payslipDetailsDialog = false"
            >
              <v-icon>fas fa-times-circle</v-icon>
            </v-btn>
            <v-toolbar-title>Payslip Details</v-toolbar-title>
             <v-spacer></v-spacer>

	     	 <v-btn @click="dialogDownload=true" :href="apiUrl+'/payslip/payslipdownload?payslip_id='+payslipDetails.payslipid" color="info" depressed>
		      <v-icon light> fas fa-download </v-icon> &nbsp; Download 
		    </v-btn>	
          </v-toolbar>	

          <v-card-text>
          	<div class="elevation-1">
	          	<div class="v-table__overflow">
				  <table
				    class="v-datatable v-table theme--light"
				  >
				      <tr>
					      <th class="text-start ">Employee ID</th><td class="text-md-center">{{payslipDetails.employee_id}}</td>
					      <th class="text-start ">Employee Name</th><td class="text-md-center">{{payslipDetails.employee_name}}</td>
				      </tr>
				       <tr>
					      <th class="text-start ">Payroll Cut-off Period </th><td class="text-md-center">{{payslipDetails.payroll_period_from + '-' + payslipDetails.payroll_period_to}}</td>
					      <th class="text-start ">Department</th><td class="text-md-center">{{payslipDetails.department}}</td>
				      </tr>
				       <tr>
					      <th class="text-start ">Payroll Date</th><td class="text-md-center">{{payslipDetails.paydate}}</td>
					      <th class="text-start ">Monthly Rate</th><td class="text-md-center">{{ formatMoney(parseFloat(payslipDetails.rate)*26) }}</td>
				      </tr>
				       <tr>
					      <th class="text-start ">Days/Hrs Worked</th>
					      <td class="text-md-center">
					      	{{ ( payslipDetails.days!=0 )? payslipDetails.days : ""  }} {{ ( payslipDetails.hrs_worked!=0 )? payslipDetails.hrs_worked : ""  }}
					  	  </td>
					      <th class="text-start ">Rate</th><td class="text-md-center">{{formatMoney(payslipDetails.rate)}}</td>
				      </tr>
				       <tr>
					      <th class="text-start ">Tax Status</th><td class="text-md-center">{{payslipDetails.tax_status}}</td>
					      <th class="text-start ">Leave Balance</th><td class="text-md-center">SL:0 &nbsp; VL:0 </td>
				      </tr>
				  </table>
				 </div>
			</div>
			<div class="elevation-1 mt-5">
	          	<div class="v-table__overflow">
				  <table
				    class="v-datatable v-table theme--light"
				  >
				  	  <tr>
					      <th class="text-md-left pl-2" colspan="2" style="width:50%">Earnings</th>
					      <th class="text-md-left pl-2" colspan="2">Amount</th>
				      </tr>
				      
				      <!--
				      <tr>
					      <td class="text-md-left pl-4 bb0" colspan="2">Tax</td>
					      <td class="text-md-right pr-2 bb0" colspan="2">7,000</td>
				      </tr>
				  	  -->
				      <tr>	
			      		<td colspan="2">
			      			<br />
			      			<p class="text-md-left pl-4 bb0"><b>Basic Pay</b></p>
			      			<template v-for="item in fields1(payslipDetails,'left')">
		      				  <p v-if="item.value!=0" class="text-md-left pl-4 bb0" colspan="2">
						      		{{item.description}} - {{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
			      			<p class="text-md-left pl-4 bb0" v-if="fields2(payslipDetails,'left')"><b>Overtime Pay</b></p>
			      			<template v-for="item in fields2(payslipDetails,'left')">
		      				  <p v-if="item.value!=0" class="text-md-left pl-5 bb0" colspan="2">
						      		{{item.description}} - {{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
			      			
			      			<p class="text-md-left pl-4 bb0" v-if="fields4(payslipDetails)"><b>Allowance</b></p>
			      			<template v-for="item in fields4(payslipDetails)">
		      				  <p v-if="item.value!=0" class="text-md-left pl-4 bb0" colspan="2">
						      		{{item.description}} - {{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
		      			</td>
			      		<td colspan="2">
			      			<br />
			      			<p class="text-md-right pr-4 bb0">{{formatMoney(payslipDetails.total_reg_wage)}}</p>
			      			<template v-for="item in fields1(payslipDetails,'right')">
		      				  <p v-if="item.value!=0" class="text-md-right pr-4 bb0" colspan="2">
						      		{{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
			      			<p class="text-md-left pl-4 bb0" v-if="fields2(payslipDetails,'right')">&nbsp;</p>
			      			<template v-for="item in fields2(payslipDetails,'right')">
		      				  <p v-if="item.value!=0" class="text-md-right pr-4 bb0" colspan="2">
						      		{{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
			      			

			      			<p class="text-md-left pl-4 bb0" v-if="fields4(payslipDetails)">&nbsp;</p>
			      			<template v-for="item in fields4(payslipDetails)">
		      				  <p v-if="item.value!=0" class="text-md-right pr-4 bb0" colspan="2">
		      				  		 {{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
		      			</td>
						      
				      </tr>
					  <tr>
					      <th class="text-md-left pl-2" colspan="2">Total Gross Pay</th>
					      <th class="text-md-right pr-4" colspan="2">{{formatMoney(totalGrossPay(payslipDetails))}}</th>
				      </tr>
				       <tr>
					      <th class="text-md-left pl-2" colspan="2">Deductions</th>
					      <th class="text-md-left pl-2" colspan="2">Amount</th>
				      </tr>
				      <tr>
					      <td  colspan="2">
					      	<br />
					      	<!--<p class="text-md-left pl-4 bb0" v-if="fields3(payslipDetails)"><b>Adjustments</b></p>-->
			      			<template v-for="item in fields3(payslipDetails)">
		      				  <p v-if="item.value!=0" class="text-md-left pl-4 bb0" colspan="2">
						      		{{item.description}} - {{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
					      	<template v-for="item in fields5(payslipDetails,'left')">
		      				  <p v-if="item.value!=0" class="text-md-left pl-4 bb0" colspan="2">
		      				  		 {{item.description}} - {{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>

					      </td>
					      <td  colspan="2">
					      	<br />
					      	<template v-for="item in fields3(payslipDetails)">
		      				  <p v-if="item.value!=0" class="text-md-right pr-4 bb0" colspan="2">
						      		{{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
					      	<template v-for="item in fields5(payslipDetails,'right')">
		      				  <p v-if="item.value!=0" class="text-md-right pr-4 bb0" colspan="2">
		      				  		{{  formatMoney(parseFloat(item.value)) }}
						      </p>
			      			</template>
					      </td>
				      </tr>
				       <tr>
					      <th class="text-md-left pl-2" colspan="2">Total Deduction</th>
					      <th class="text-md-right pr-4" colspan="2">{{formatMoney(totalDeduction(payslipDetails))}}</th>
				      </tr>
				       <tr>
					      <th class="text-md-left pl-2" colspan="2">Net Pay</th>
					      <th class="text-md-right pr-4"  colspan="2">
					      {{ 
					      		formatMoney( 
					      			(totalGrossPay(payslipDetails) - totalDeduction(payslipDetails)) )   

					      }}

					      </th>
				      </tr>
				  </table>
				 </div>
			</div>
          </v-card-text>

          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>

      <v-dialog
	      v-model="dialogDownload"
     	  max-width="290"
	    >
	      <v-card>
	      	<v-card-title>
		      <center><span class="title font-weight-medium">Message</span></center>
	        </v-card-title>

	        <v-card-text>
	          Start downloading, please wait...
	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	          <v-btn
	            depressed
	            text
	            @click="dialogDownload = false"
	          >
	            Close
	          </v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>

	</v-layout>
</template>
<style scoped>
	.payslip-detail-top {
		padding: 20px;
	}
	table tr th, table  tr td:not(:last-child) {
	    border-right: 1px solid rgb(221, 221, 221);
	}
	table.v-table  td, table.v-table  th {
	    height: 48px;
	}	
	table  tr th, table  tr td, table tr td:not(:last-child){
	    border: 1px solid #bbb !important;
	}
	.bb0 {
		border-bottom: 0px;
	}
</style>
<script>
	import VueCookies from 'vue-cookies';
	import axios from 'axios';

	export default {
		created : function(){
			this.token = (VueCookies.get(this.cookieKey)).token;
			let _this = this;
			_this.token = (VueCookies.get(_this.cookieKey)).token;
			_this.id = (VueCookies.get(_this.cookieKey)).data.user.id;
			_this.eventHub.$emit("openGlobalLoaderModal");
			_this.getUsers()
			.then(function(res){
				_this.employee.fname = res.data.data.firstname;
				_this.employee.lname = res.data.data.lastname;
				_this.employee.employee_id = res.data.data.employee_id;
				_this.employee.id = res.data.data.id;

				_this.getAndListPayslips();

				_this.eventHub.$emit("closeGlobalLoaderModal");
			});
		},

		data : function() {
			return {
				token : '',
				id : 0,
				payslips : [],
				employee : {
					fname : '',
					lname : '',
					employee_id : '',
					id : ''
				},
				pagination : {
					length : 0,
					page : 1
				},
				isLoading : false,
				payslipDetailsDialog : false,
				payslipDetails : [],
				dialogDownload: false
			}
		},

		mounted : function(){
			
		},

		watch : {
			"pagination.page" : function(){
				this.getAndListPayslips();
			}
		},
		
		methods : {
			payslipDetailsFunc : function(item){
				console.log(item);
				this.payslipDetails = item;
				this.payslipDetailsDialog = true;
			},		
			formatMoney : function(number, decPlaces, decSep, thouSep) {
				decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
				decSep = typeof decSep === "undefined" ? "." : decSep;
				thouSep = typeof thouSep === "undefined" ? "," : thouSep;
				var sign = number < 0 ? "-" : "";
				var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
				var j = (j = i.length) > 3 ? j % 3 : 0;

				return sign +
					(j ? i.substr(0, j) + thouSep : "") +
					i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
					(decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
			},	
			getAndListPayslips : function(){
				this.eventHub.$emit("openGlobalLoaderModal");
				this.getPayslips()
				.then((response) => {
					this.listPayslip(response.data.data);
					console.log(response);
					this.eventHub.$emit("closeGlobalLoaderModal");
				});

			},

			getPayslips : function(){
				let _this = this;
				return axios.create({
					baseURL : this.apiUrl,
					headers : {
						'Authorization' : `Bearer ${_this.token}`
					}
				})
				.get('/payslip/list', {
					'params' : {
						'id' : _this.employee.id,
						'page' : _this.pagination.page
					}
				});
			},

			getUsers : function(){
				let _this = this;
				return axios.create({
					baseURL : _this.apiUrl,
					headers : {
						'Authorization' : `Bearer ${_this.token}`
					}
				})
				.get('/users/profile', {
					'params' : {
						'id' : _this.id
					}
				});
			},
			listPayslip : function(data){
				console.log('data', data);
				this.payslips = data.payslips;
				this.pagination.length = data.pagination.pages
			},
			fields1 : function(items,position="left"){
				if(this.payslipDetailsDialog){
					let fields = {
						leave_count : { description: "Leave"},
						night_diff_hrs : { description: "Night Differential" },
						night_diff_amt : { description: "Night Differential Amount" },
						night_diff_rd_hrs : { description: "Night Differential RD" },
						night_diff_rd_amt : { description: "Night Differential RD" },
						night_diff_special_hol_hrs : { description: "Night Differential SH" },
						night_diff_special_hol_amt : { description: "Night Differential SH" },
						night_diff_legal_hol_hrs : { description: "Night Differential LH" },
						night_diff_legal_hol_amt : { description: "Night Differential LH" },
						night_diff_special_hol_rd_hrs : { description: "Night Differential SH RD" },
						night_diff_special_hol_rd_amt : { description: "Night Differential SH RD" },
						night_diff_legal_hol_rd_hrs : { description: "Night Differential LH RD" },
						night_diff_legal_hol_rd_amt : { description: "Night Differential LH RD" },
						special_hol_hrs : { description: "Special Holiday" },
						special_hol_amt : { description: "Special Holiday" },
						legal_hol_hrs : { description: "Legal Holiday" },
						legal_hol_amt : { description: "Legal Holiday" },
						special_hol_rd_hrs : { description: "SH Rest Day" },
						special_hol_rd_amt : { description: "SH Rest Day" },
						legal_hol_rd_hrs : { description: "LH Rest Day" },
						legal_hol_rd_amt : { description: "LH Rest Day" },
						adj_adjustment_salary : { description: "Adjustment Salary" },
						
					};

					let o = [];
					let k = 0;

					for(let i in fields){

						if(position=="left"){
							if(i.includes("hrs")) {
								o[k] = {'value': items[i], 'description': fields[i]['description']};
							}else if(i=='adj_adjustment_salary') {
								o[k] = {'value': items[i], 'description': fields[i]['description']};
							}else{
								o[k] = {'value': 0, 'description': fields[i]['description']};
							}
							
						}else{
							if(i.includes("hrs")) {
								o[k] = {'value': 0, 'description': fields[i]['description']};
							}else{
								o[k] = {'value': items[i], 'description': fields[i]['description']};
							}
						}

						k++;
					}

					console.log(position);
					console.log("aaa");
					console.log(o);


					return o;
				}
			},
			fields2 : function(items,position="left"){
				if(this.payslipDetailsDialog){
					let fields = {
						reg_ot_hrs : { description: "Regular" },
						reg_ot_amt : { description: "Regular" },
						night_diff_ot_hrs : { description: "Night Differential" },
						night_diff_ot_amt : { description: "Night Differential" },
						night_diff_special_hol_ot_hrs : { description: "Night Differential SH" },
						night_diff_special_hol_ot_amt : { description: "Night Differential SH" },
						night_diff_legal_hol_ot_hrs : { description: "Night Differential LH" },
						night_diff_legal_hol_ot_amt : { description: "Night Differential LH" },
						night_diff_special_hol_rd_ot_hrs : { description: "Night Differential SH RD" },
						night_diff_special_hol_rd_ot_amt : { description: "Night Differential SH RD" },
						night_diff_legal_hol_rd_ot_hrs : { description: "Night Differential LH RD" },
						night_diff_legal_hol_rd_ot_amt : { description: "Night Differential LH RD" },
						rd_ot_hrs : { description: "Rest Day" },
						rd_ot_amt : { description: "Rest Day" },
						special_hol_ot_hrs : { description: "Special Holiday" },
						special_hol_ot_amt : { description: "Special Holiday" },
						special_hol_rd_ot_hrs : { description: "SH Rest Day" },
						special_hol_rd_ot_amt : { description: "SH Rest Day" },
						legal_hol_ot_hrs : { description: "Legal Holiday" },
						legal_hol_ot_amt : { description: "Legal Holiday" },
						legal_hol_rd_ot_hrs : { description: "LH Rest Day" },
						legal_hol_rd_ot_amt : { description: "LH Rest Day" },
					};

					let o = [];
					let k = 0;

					for(let i in fields){
						if(position=="left"){
							if(i.includes("hrs")){
								o[k] = {'value': items[i], 'description': fields[i]['description']};
							}else{
								o[k] = {'value': 0, 'description': fields[i]['description']};
							}
						}else{
							if(i.includes("hrs")){
								o[k] = {'value': 0, 'description': fields[i]['description']};
							}else{
								o[k] = {'value': items[i], 'description': fields[i]['description']};
							}
						}

						k++;
					}
					return o;
				}
			},
			fields3 : function(items){
				if(this.payslipDetailsDialog){
					let fields = {
						adj_add_back_night_diff : { description: "Add Back Night Differential" },
						adj_add_back_holiday : { description: "Add Back Holiday" },
						adj_add_back_ecola : { description: "Add Back Ecola" },
						adj_incentives_bonus : { description: "Incentives Bonus" },
						adj_tax_refund : { description: "Tax Refund" },
						adj_sl_conversion : { description: "SL Conversion" },
						adj_add_back_meal_allowance : { description: "Add Back Meal Allowance" },
						adj_refund_dona_maria : { description: "Refund Doña Maria" },
						adj_medical_reimbursement : { description: "Medical Reimbursement" },
						adj_add_back_bistro : { description: "Add Back Bistro" },
						adj_add_back_headset : { description: "Add Back Headset" },
						adj_leave_adjustment : { description: "Leave Adjustment" },
						adj_lead_premium : { description: "Lead Premium" },
						adj_top_agent : { description: "Top Agent" },
						adj_perfect_attendance : { description: "Perfect Attendance" },
						adj_qa_superstar : { description: "QA Superstar" },
						adj_13th_month : { description: "13th Month" },
						adj_referral_incentives : { description: "Referral Incentives" },
						adj_vl_conversion : { description: "VL Conversion" },
						adj_add_back_cntnhelen : { description: "Add Back Canteen Helen" },
						adj_performance_incentives : { description: "Performance Incentives" },
						adj_retro_basic_only : { description: "Retro Basic Only" },
						adj_add_back_transpo : { description: "Add Back Transpo" },
						adj_add_back_non_tax : { description: "Add Back Non Tax" },
						adj_wage_increase : { description: "Wage Increase" },
						adj_adjustment_p20 : { description: "Adjustment p20" },
						adj_adjustment_holiday : { description: "Adjustment Holiday" },
						adj_allowance : { description: "Allowance" },
						adj_add_back_canteen_bistro : { description: "Add Back Canteen Bistro" },
						adj_add_back_over_deduction : { description: "Add Back Over Deduction" },
						adj_meal_allowance : { description: "Meal Allowance" },
						adj_add_back_sss_loan : { description: "Add Back SSS Loan" },
						adj_telephone_allowance : { description: "Telephone Allowance" },
						adj_top_agent_incentives : { description: "Top Agent Incentives" },
						adj_adjustment : { description: "Adjustment" },
						adj_training_allow : { description: "Training Allow" },
						adj_over_pyt_adjustment : { description: "Over Payment Adjustment" },
					};

					let o = [];
					let k = 0;

					for(let i in fields){
						o[k] = {'value': items[i], 'description': fields[i]['description']};
						k++;
					}

					return o;
				}
			},
			fields4 : function(items){
				if(this.payslipDetailsDialog){
					let fields = {
						allowance_ecola : { description: "Ecola" },
						allowance_non_taxable_income : { description: "Non-Taxable Income" },
						allowance_add_back_non_taxable : { description: "Add Back Non-Taxable" },
						allowance_telephone_allowance : { description: "Telephone Allowance" },
						allowance_representation_allowance : { description: "Representation Allowance" },
						allowance_meal : { description: "Meal" },
						allowance_adjustment : { description: "Adjustment" },
						allowance_transpo : { description: "Transpo" },
						allowance_allowance : { description: "Allowance" },
						allowance_over_pyt_ecola : { description: "Over Payment Ecola" },
						allowance_ecola_monthly : { description: "Ecola Monthly" },
						allowance_ecola_hourly : { description: "Ecola Hourly" },
						allowance_transpo_hourly : { description: "Transpo Hourly" },
						adj_add_back_training_allowance : { description: "Add Back Training Allowance" },
						adj_add_back : { description: "Add Back" },
					};

					let o = [];
					let k = 0;

					for(let i in fields){
						o[k] = {'value': items[i], 'description': fields[i]['description']};
						k++;
					}

					return o;
				}
			},
			fields5 : function(items,position="left"){
				if(this.payslipDetailsDialog){
					let fields = {
						absences : { description: "Absences" },
						//undertime : { description: "Undertime" },
						tardy : { description: "Tardiness" },
						sss_contribution : { description: "SSS Prem" },
						philhealth_contribution : { description: "PhilHealth Prem" },
						hdmf_contribution : { description: "HDMF Prem" },
						w_tax_contribution : { description: "Tax Withheld" },
						adj_over_payment : { description: "Over Payment" },
						loan_pagibig_salary_loan : { description: "PAG-IBIG Salary Loan" },
						loan_pagibig_calamity_loan : { description: "PAG-IBIG Calamity Loan" },
						loan_sss_salary_loan : { description: "SSS Salary Loan" },
						loan_sss_calamity_loan : { description: "SSS Calamity Loan" },
						loan_atd_sun : { description: "ATD SUN" },
						loan_canteen_anne : { description: "Canteen Anne" },
						loan_canteen_racs : { description: "Canteen RACS" },
						loan_canteen_maria : { description: "Canteen Maria" },
						loan_cash_advance : { description: "Cash Advance" },
						loan_headset : { description: "Headset" },
						loan_xmas_party_charges : { description: "XMAS Party Charges" },
						loan_salary_loan : { description: "Salary Loan" },
						loan_others_per : { description: "Others Per" },
						loan_rice : { description: "Rice" },
						loan_bazaar : { description: "Bazaar" },
						loan_bazaar_y : { description: "Bazaar Y" },
						loan_bazaar_j : { description: "Bazaar J" },
						loan_bazaar_r : { description: "Bazaar R" },
						loan_bazaar_b : { description: "Bazaar B" },
						loan_gym : { description: "Gym" },
						loan_gift_to_officer : { description: "Gift to Officer" },
						loan_medical : { description: "Medical" },
						loan_charges_to_employees : { description: "Charges to Employees" },
						loan_school_supplies : { description: "School Supplies" },
						loan_chamco : { description: "CHAMCO" },
						loan_canteen_bistro : { description: "Canteen Bistro" },
						loan_canteen_adjustments : { description: "Canteen Adjustments" },
						loan_anne_adj2 : { description: "Anne Adjustment2" },
						loan_anne_adj3 : { description: "Anne Adjustment3" },
						loan_tshirt : { description: "T-Shirt" },
						loan_bazaar_sp : { description: "Bazaar SP" },
						loan_ham : { description: "Ham" },
						loan_tonka : { description: "Tonka" },
						loan_overpayment_sss : { description: "Overpayment SSS" },
						loan_puppy : { description: "Puppy" },
						loan_cellphone_loan : { description: "Cellphone Loan" },
						loan_id : { description: "ID" },
						loan_canteen_aelys : { description: "Canteen Aelys" },
						loan_sports : { description: "Sports" },
						loan_bazaar_sp1 : { description: "Bazaar SP1" },
						loan_canteen_others : { description: "Canteen Others" },
						loan_others_light : { description: "Others Light" },
						loan_canteen_bistro_adj : { description: "Canteen Bistro Adjustment" },
						loan_atd_amber : { description: "ATD Amber" },
						loan_atd_bonchon : { description: "ATD BonChon" },
						loan_atd_chowking : { description: "ATD Chowking" },
						loan_atd_jollibee : { description: "ATD Jollibee" },
						loan_personal_calls : { description: "Personal Calls" },
						loan_atd_greenwich : { description: "ATD Greenwich" },
						loan_over_payment : { description: "Over Payment" },
						loan_medicard : { description: "Medicard" },
						loan_canteen_veras : { description: "Canteen Veras" },
						loan_lantern : { description: "Lantern" },
						loan_ticket_ek : { description: "Ticket EK" },
						loan_others : { description: "Others" },
						loan_canteen_arman_mrl : { description: "Canteen Arman MRL" },
						loan_canteen_helen_mrl : { description: "Canteen Helen MRL" },
						loan_credit_coop : { description: "Credit COOP" },
						loan_bazaar_sp_oct : { description: "Bazaar SP Oct" },
						loan_atd_ham : { description: "ATD Ham" },
						loan_hmo : { description: "HMO" },
						loan_canteen_arman_adj : { description: "Canteen Arman Adjustment" },
						loan_pagibig_id : { description: "PAG-IBIG ID" },
						loan_sg_coop : { description: "SG COOP" },
						loan_bazaar_dec : { description: "Bazaar Dec" },
						loan_christmas_party : { description: "Christmas Party" },
						loan_bazaar_feb : { description: "Bazaar Feb" },
						loan_bazaar_mrl : { description: "Bazaar MRL" },
						loan_kopiko : { description: "Kopiko" },
						loan_atd_binalot : { description: "ATD Binalot" },
						loan_canteen_mavis : { description: "Canteen Mavis" },
						loan_bazaar_galleon : { description: "Bazaar Galleon" },
						loan_staff_house : { description: "Staff House" },
						loan_canteen_brewed : { description: "Canteen Brewed" },
						loan_canteen_cyds : { description: "Canteen Cyds" },
						loan_canteen_rnfs : { description: "Canteen Rnfs" },
						loan_canteen_snack : { description: "Canteen Snack" },
						fix_deduction_union_dues : { description: "Fix Deduction Union Dues" },
						fix_deduction_adjustment_overpayment : { description: "Fix Deduction Adjustment Overpayment" },
						fix_deduction_globe_personal : { description: "Fix Deduction Globe Personal" },
						fix_deduction_smart_personal : { description: "Fix Deduction Smart Personal" },
						loan_aub_salary_loan : { description: "AUB Salary Loan" },
						loan_car_loan : { description: "Car Loan" },
						loan_personal_loan : { description: "Personal Loan" },
						loan_company_loan : { description: "Company Loan" },
						loan_company_salary_loan : { description: "Company Salary Loan" },
						loan_atd_smart : { description: "ATD Smart" },
						loan_smart_personal_calls : { description: "Smart Personal Calls" },
						loan_management_lounge : { description: "Management Lounge" },
						loan_adv_to_employees : { description: "Advance to Employees" },
						loan_pnblife_personal : { description: "PNB Life Personal" },
						loan_travel_loan : { description: "Travel Loan" },
						loan_globe_personal : { description: "Globe Personal" },
						loan_cedula : { description: "Cedula" },
					};

					let o = [];
					let k = 0;

					for(let i in fields){
						if(position=="left"){
							if(i=="tardy"){
								o[k] = {'value': (parseFloat(items['tardy']) + parseFloat( (items['undertime'].length>0?items['undertime']:0) )), 'description': fields[i]['description']};
							}else if(i=="absences"){
								o[k] = {'value': (parseFloat(items['absences'])), 'description': fields[i]['description']};
							}else{
								o[k] = {'value': items[i], 'description': fields[i]['description']};
							}
						}else{
							if(i=="tardy"){
								o[k] = {'value': (parseFloat(items['undertime_amt']) + parseFloat( (items['tardy_amt'].length>0?items['tardy_amt']:0) )), 'description': fields[i]['description']};
							}else if(i=="absences"){
								o[k] = {'value': (parseFloat(items['absences_amt'])), 'description': fields[i]['description']};
							}else{
								o[k] = {'value': items[i], 'description': fields[i]['description']};
							}
							
						}
						k++;
						
					}

					//console.log(o);
					return o;
				}
			},
			totalAdj: function(items){
				let ta = 0;
				for(var i in this.fields3(items)){
					//console.log(this.fields1(items)[i].value);
					ta += parseFloat(this.fields3(items)[i]['value']) ;
				}

				return ta;

			},
			totalGrossPay : function(items){
				console.log(items);
				let trw = parseFloat(items.total_reg_wage);
				let tgp = 0;

				for(var i in this.fields1(items,'right')){
					//console.log(this.fields1(items)[i].value);
					tgp += parseFloat(this.fields1(items,'right')[i]['value']) ;
				}

				for(var i in this.fields2(items,'right')){
					//console.log(this.fields1(items)[i].value);
					tgp += parseFloat(this.fields2(items,'right')[i]['value']) ;
				}

				
				for(var i in this.fields4(items)){
					//console.log(this.fields1(items)[i].value);
					tgp += parseFloat(this.fields4(items)[i]['value']) ;
				}

				return parseFloat(tgp + trw);
			},
			totalDeduction : function(items){

				let td = 0;
				console.log(items);
				
			
				//td +=  items['adj_over_pyt_adjustment'];

				for(var i in this.fields3(items)){
					//console.log(this.fields1(items)[i].value);
					td += parseFloat(this.fields3(items)[i]['value']) ;
				}


				for(var i in this.fields5(items,'right')){
					//console.log(this.fields1(items)[i].value);
					td += parseFloat(this.fields5(items,'right')[i]['value']) ;
				}

				return parseFloat(td);
			}

		},

	};
</script>